import styled from 'styled-components';
import { fonts, colors } from 'stylesheets';

import { Button } from 'triider-components';

export const DocumentContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0 0px;
  height: ${({ loading }) => (loading === 'true' ? '600px' : 'auto')};
`;

export const DocumentBackground = styled.div`
  margin: 0px auto 0;
  background: #eeeeee;
  border: 1px solid #a1a1a1;
  display: grid;
  width: 100%;
`;

export const Document = styled.iframe`
  width: 100%;
  height: 65vh;
  transform: scale(0.9);
  zoom: 1.2;
`;

export const DocumentHeader = styled.div`
  display: flex;
  padding-top: 10px;
  padding-bottom: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const DownloadButton = styled(Button)`
  margin: 0 auto;
  width: 135px;
  height: 30px;
  font-size: 10px;
  border-radius: 3px;

  & > img {
    margin-right: 5px;
  }
`;

export const Text = styled.p`
  margin: 0 auto;
  font-size: 20px;
  font-family: ${fonts.secondary};
  color: ${({ color }) => color || colors.greyDark};
`;

export const TextColor = styled.div`
  font-size: 30px;
  font-weight: 400;
  color: ${({ color }) => color || colors.greyDark} !important;
`;
